
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vlog/skeleton/recent_video_skeleton",
      function () {
        return require("private-next-pages/vlog/skeleton/recent_video_skeleton.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vlog/skeleton/recent_video_skeleton"])
      });
    }
  